export default "__VITE_ASSET__B4P4Swnz__"